import { render, staticRenderFns } from "./overseasContactUsManagement.vue?vue&type=template&id=61657a1f&scoped=true"
import script from "./overseasContactUsManagement.vue?vue&type=script&lang=js"
export * from "./overseasContactUsManagement.vue?vue&type=script&lang=js"
import style0 from "./overseasContactUsManagement.vue?vue&type=style&index=0&id=61657a1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61657a1f",
  null
  
)

export default component.exports